import type { ReactNode } from 'react'
import { ShieldAlert } from 'lucide-react'
import { EmptyState } from './states'
import { useSession } from '../lib/session'

/**
 * Everything under `/school` is admin-only. The API enforces it too — a teacher
 * hitting these routes gets a 403 — but a teacher should never be shown a screen
 * that can only fail.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin } = useSession()

  if (!isAdmin) {
    return (
      <div className="animate-fade-up">
        <EmptyState
          icon={<ShieldAlert size={22} />}
          title="Admins only"
          body="Roster, structure, settings and billing are managed by your school's admins. Your groups and students are all available from Overview."
        />
      </div>
    )
  }

  return <>{children}</>
}
